var _circle, _circle2, _circle3, _path, _rect, _path2, _rect2, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#1a2266"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "none",
    stroke: "#3344aa",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 38,
    r: 14,
    fill: "#8899cc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 56 C44 52 76 52 76 56 L74 68 46 68 Z",
    fill: "#8899cc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 68,
    width: 36,
    height: 6,
    rx: 2,
    fill: "#8899cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 74 C38 74 36 88 36 90 L84 90 C84 88 82 74 82 74 Z",
    fill: "#8899cc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 90,
    width: 52,
    height: 8,
    rx: 3,
    fill: "#8899cc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 38,
    r: 14,
    fill: "none",
    stroke: "#ffd700",
    strokeWidth: 1,
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.ecefebb1f1d349c0ae8d3c898bcc66b3.svg";
export { ForwardRef as ReactComponent };